import React from "react";
import PropTypes from "prop-types";

import { CommonControls } from "./CommonControls";
import { LeftButtons } from "./buttons/LeftButtons";
import { TopControls } from "./TopControls";

export const FullControls = ({
  config,
  isVertical,
  carouselEnd,
  isLive,
  closeCarousel,
  hasSubtitles
}) => (
  <CommonControls
    config={config}
    isVertical={isVertical}
    carouselEnd={carouselEnd}
    TopControls={TopControls}
    LeftButtons={LeftButtons}
    closeCarousel={closeCarousel}
    hasSubtitles={hasSubtitles}
    isLive={isLive}
  />
);

FullControls.propTypes = {
  config: PropTypes.object,
  isVertical: PropTypes.bool,
  carouselEnd: PropTypes.bool,
  isLive: PropTypes.bool,
  closeCarousel: PropTypes.func,
  hasSubtitles: PropTypes.bool
};
